var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDefaultImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1000px",
    height: "1000px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#545554",
    d: "M962.067,724.611v272.031H796.756V485.968C889.256,495.593,962.067,598.759,962.067,724.611z  M37.569,724.611v272.031h151.717V488.079C103.347,505.87,37.569,604.993,37.569,724.611z M614.973,463.804 c74.15-42.392,124.128-122.246,124.128-213.776c0-135.906-110.175-246.08-246.081-246.08s-246.08,110.174-246.08,246.08 c0,91.821,50.297,171.885,124.836,214.172l-36.425,21.03H220.785v511.413h253.528l-63.961-483.631v-27.782v-3.371 c25.839,9.215,53.664,14.248,82.668,14.248c29.525,0,57.833-5.206,84.064-14.74v3.862v17.256l-65.355,494.157h253.528V485.229 H652.084L614.973,463.804z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDefaultImage);
export default __webpack_public_path__ + "static/media/icon-defaultImage.7fa1d003bc590b98225a60aed31a788c.svg";
export { ForwardRef as ReactComponent };